
import Vue from 'vue';
import BaseStyledMenu from '@/components/base/BaseStyledMenu.vue';
import { BoardsFilter } from '@/views/Runnits/pages/RunnitBoardsPage/types';
import { TeamUserMixin } from '@/mixins';
import { mapGetters } from 'vuex';

export default Vue.extend({
	name: 'RunnitBoardsFilterMenu',
	mixins: [
		TeamUserMixin,
	],
	components: {
		BaseStyledMenu,
	},
	props: {
		value: {
			type: String,
			required: true,
		},
		isOpen: {
			type: Boolean,
			default: false,
		},
		isTemplate: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapGetters([
			'displayLabels',
		]),
		selectedFilterMenuItem (): any {
			return this.filterMenuItems.find(item => item.value === this.value) || {
				id: -1,
				icon: 'mdi-filter-variant',
				label: 'Filter',
				description: '',
				value: BoardsFilter.ALL,
			};
		},
		filterMenuItems () {
			let idIncrementer: number = 0;
			return [
				// All boards
				{
					id: idIncrementer++,
					icon: 'mdi-apps',
					label: this.isTemplate ? 'All templates' : 'All boards',
					description: this.isTemplate ? 'Your private templates and all templates shared with you' : 'Your private boards and all boards shared with you',
					value: BoardsFilter.ALL,
				},
				// Private boards
				{
					id: idIncrementer++,
					icon: 'mdi-account-star-outline',
					label: this.isTemplate ? 'My templates' : 'My boards',
					description: this.isTemplate ? 'Only templates you are the owner of' : 'Only boards you are the owner of',
					value: BoardsFilter.MY_BOARDS,
				},
				// Shared with me
				{
					id: idIncrementer++,
					icon: 'mdi-account-multiple-outline',
					label: 'Shared with me',
					description: this.isTemplate ? 'Your shared templates and other templates shared with you' : 'Your shared boards and other boards shared with you',
					value: BoardsFilter.SHARED_WITH_ME,
				},
				// Everyone's boards (users with MANAGE_ALL_GENERATIONS permission)
				...(this.hasManageAllGenerationsPermission ? [{
					id: idIncrementer++,
					icon: 'mdi-shield-account',
					label: this.isTemplate ? "Everyone's templates" : "Everyone's boards",
					description: this.isTemplate ? `(Admin) All templates across the ${this.displayLabels.team}` : `(Admin) All boards across the ${this.displayLabels.team}`,
					value: BoardsFilter.EVERYONES_BOARDS,
				}] : []),
				// Featured templates (only for templates)
				...(this.isTemplate ? [{
					id: idIncrementer++,
					icon: 'mdi-star',
					label: 'Featured',
					description: 'Featured templates visible to all users',
					value: BoardsFilter.FEATURED_TEMPLATES,
				}] : []),
			];
		},
	},
	methods: {
		onChange (filter: BoardsFilter) {
			this.$emit('input', filter);
		},
	},
});
